/** Class to extend api services with */
export class ApiBaseClient {
	private static readonly baseUri = 'client/v2';

	constructor(
		/** The target backend index endpoint */
		private readonly controller: string,
	) {
		// Empty
	}

	/** Returns a concatenated string containing the base uri plus the controller */
	protected getBaseUri(): string {
		return `${ApiBaseClient.baseUri}/${this.controller}`;
	}
}
